import { colors } from 'pages/Home/Home.styles';
import { useState } from 'react';
import Loader from "../loader";
export const LazyImage = ({ src, alt, style = {}, className = '' }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div
      style={{ position: 'relative', width: "100%", height: "100%", ...style }}
      className={className}
    >
      {!loaded && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: colors.background,
          }}
        >
          <Loader/> {/* Puedes usar un spinner aquí */}
        </div>
      )}

      <img
        src={src}
        alt={alt}
        onLoad={() => setLoaded(true)}
        style={{
          opacity: loaded ? 1 : 0,
          transition: 'opacity 0.3s ease-in-out',
          display: 'block',
        }}
      />
    </div>
  );
};